import { Button } from 'foundations-components/transitional/components/Button';
import { Metrics } from '../../../metrics/Metrics';

/**
 * @temporary We're tracking link clicks while actively iterating on this feature. We should remove the tracking when we're done iterating.
 * @expiration 2025-06-30
 * @deprecated
 */
import { jsx as _jsx } from "react/jsx-runtime";
const trackPropertyInformationPopoverLinkClick = linkType => {
  Metrics.counter('prop_info_pop_link_click', {
    ['link_type']: linkType
  }).increment();
};
export default function PropertyInformationPopoverLink({
  children,
  href,
  linkType
}) {
  // Don't use UILink becuase when both `truncate` and `external` are `true`,
  //   the external icon appears outside (to the right) of the space, causing unwanted scrolling.
  return /*#__PURE__*/_jsx(Button, {
    use: "link",
    href: href,
    external: true,
    truncate: true,
    responsive: false,
    onClick: event => {
      // prevent clicks inside the popover from triggering property selection
      event.stopPropagation();
      trackPropertyInformationPopoverLinkClick(linkType);
    },
    children: children
  });
}